module.exports = __webpack_public_path__ + "static/media/hall-P6-2026.a4d2f334.svg";